import { reducer as adminInvoices } from "./Containers/AdminInvoicesPage/reducer"
import { reducer as adminUsers } from "./Containers/AdminUsersPage/reducer"
import { reducer as alerts } from "./Containers/AlertsPage/reducer"
import { reducer as balance } from "./Containers/Balance/reducer"
import { reducer as businessAccounts } from "./Containers/BusinessAccountsPage/reducer"
import { reducer as businessDetails } from "./Containers/BusinessDetailsBlock/reducer"
import { persistedReducer as credits } from "./Containers/CreditsPage/reducer"
import { reducer as dashboard } from "./Containers/DashboardPage/reducer"
import { reducer as globalFilters } from "./Containers/GlobalFilters/reducer"
import { persistedReducer as health } from "./Containers/Health/reducer"
import { reducer as invoices } from "./Containers/InvoiceHistoryBlock/reducer"
import { reducer as auth } from "./Containers/LoginPage/reducer"
import { reducer as marketing } from "./Containers/MarketingPage/reducer"
import { reducer as notifications } from "./Containers/Notifications/reducer"
import { reducer as paymentMatching } from "./Containers/PaymentMatchingPage/reducer"
import { reducer as perksAdmin } from "./Containers/PerksAdminPage/reducer"
import { reducer as perks } from "./Containers/PerksPage/reducer"
import { reducer as publicApi } from "./Containers/PersonalSettings/PublicAPI/reducer"
import { reducer as pricing } from "./Containers/PricingPage/reducer"
import { reducer as referrals } from "./Containers/Referrals/reducer"
import { reducer as requests } from "./Containers/RequestsPage/reducer"
// import { reducer as requestsDescriptors } from './Containers/RequestsPage/RequestsDescriptors/reducer';
import { reducer as requestsAutoRefund } from "./Containers/RequestsPage/RequestsAutoRefund/reducer"
import { reducer as requestsEnrollments } from "./Containers/RequestsPage/RequestsEnrollments/reducer"
import { reducer as requestsGifts } from "./Containers/RequestsPage/RequestsGifts/reducer"
import { reducer as requestsIntegrations } from "./Containers/RequestsPage/RequestsIntegrations/reducer"
import { persistedReducer as requestsVerifiInform } from "./Containers/RequestsPage/RequestsVerifiInform/reducer"
import { reducer as requestsWithdrawal } from "./Containers/RequestsPage/RequestsWithdrawal/reducer"
//import { reducer as breadCrumbs } from './Containers/Breadcrumbs/actions';
import { reducer as setting } from "./Containers/Setting/reducer"
import { reducer as user } from "./Containers/User/reducer"
import { reducer as users } from "./Containers/UsersPage/reducer"
import { reducer as errors } from "./Redux/ErrorsRedux"
import { reducer as nav } from "./Redux/NavRedux"
import { reducer as startup } from "./Redux/StartupRedux"

export const reducers = {
  auth,
  notifications,
  nav,
  errors,
  startup,
  user,
  dashboard,
  alerts,
  //breadcrumbs: breadCrumbs,
  setting,
  users,
  businessAccounts,
  adminUsers,
  requestsEnrollments,
  // requestsDescriptors,
  requestsAutoRefund,
  requestsIntegrations,
  requestsGifts,
  requestsWithdrawal,
  requestsVerifiInform,
  adminInvoices,
  pricing,
  invoices,
  globalFilters,
  credits,
  balance,
  marketing,
  requests,
  referrals,
  businessDetails,
  publicApi,
  health,
  perks,
  paymentMatching,
  perksAdmin
}

export default reducers
